import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormControlTypes } from '@shared/models/form-controls';

@Component({
	selector: 'app-standard-control',
	imports: [CommonModule, FormsModule, ReactiveFormsModule],
	templateUrl: './standard-control.component.html',
	styleUrl: './standard-control.component.scss',
})
export class StandardControlComponent<T extends { [K in keyof T]: AbstractControl }> {
	@Input() formGroup!: FormGroup<T>;
	@Input() type: FormControlTypes = 'text';
	@Input() name!: Extract<keyof T, string | number>;
	@Input() label: string;
	@Input() labelPlacement: 'floating' | 'above' | 'none' = 'floating';
	@Input() placeholder: string;
	@Input() autocomplete?: string;
	@Input() patternMessage?: string = 'Invalid format';
	@Input() smallPadding: boolean = false;
	@Input() dataListOptions: Array<string> = [];

	get control() {
		return this.formGroup.controls[this.name];
	}

	Validators = Validators;
}
